import SplitTime from './observer';
export default SplitTime;
//# sourceMappingURL=index.js.map